export interface Pillar {
  slug: string;
  icon: string;
  image: string;
  readTime: string;
}

export const pillars: Pillar[] = [
  {
    slug: 'review',
    icon: 'ri-star-line',
    readTime: '6 min read',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20editorial%20flat%20lay%20concept%20of%20a%20notebook%20with%20a%20five%20star%20rating%20motif%20in%20soft%20sage%20green%20and%20warm%20cream%20tones%20abstract%20minimal%20composition%20with%20soft%20shadows%20clean%20contemporary%20aesthetic%20no%20text&width=800&height=500&seq=pillar-review-01&orientation=landscape',
  },
  {
    slug: 'shipping',
    icon: 'ri-ship-line',
    readTime: '7 min read',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20minimal%20illustration%20of%20a%20cardboard%20shipping%20box%20with%20a%20dotted%20route%20line%20and%20location%20pins%20in%20soft%20pastel%20colors%20on%20a%20light%20cream%20background%20clean%20modern%20flat%20design%20style&width=800&height=500&seq=pillar-shipping-01&orientation=landscape',
  },
  {
    slug: 'coupon',
    icon: 'ri-coupon-3-line',
    readTime: '5 min read',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20minimal%20illustration%20of%20a%20discount%20price%20tag%20with%20scissors%20on%20a%20soft%20cream%20background%20in%20warm%20pastel%20amber%20and%20sage%20tones%20clean%20modern%20flat%20design%20style%20no%20text&width=800&height=500&seq=pillar-coupon-01&orientation=landscape',
  },
  {
    slug: 'warehouse',
    icon: 'ri-archive-line',
    readTime: '6 min read',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20minimal%20illustration%20of%20neatly%20stacked%20cardboard%20boxes%20in%20a%20bright%20airy%20warehouse%20with%20soft%20natural%20light%20in%20pastel%20colors%20clean%20modern%20flat%20design%20style&width=800&height=500&seq=pillar-warehouse-01&orientation=landscape',
  },
  {
    slug: 'legit',
    icon: 'ri-shield-check-line',
    readTime: '5 min read',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20minimal%20illustration%20of%20a%20shield%20with%20a%20checkmark%20in%20soft%20sage%20green%20and%20cream%20tones%20on%20a%20light%20background%20trustworthy%20concept%20clean%20modern%20flat%20design%20style&width=800&height=500&seq=pillar-legit-01&orientation=landscape',
  },
  {
    slug: 'qc',
    icon: 'ri-search-eye-line',
    readTime: '6 min read',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20minimal%20illustration%20of%20a%20magnifying%20glass%20over%20a%20checklist%20in%20soft%20warm%20amber%20and%20cream%20tones%20on%20a%20light%20background%20quality%20control%20concept%20clean%20modern%20flat%20design%20style&width=800&height=500&seq=pillar-qc-01&orientation=landscape',
  },
  {
    slug: 'beginner',
    icon: 'ri-rocket-line',
    readTime: '8 min read',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20minimal%20illustration%20of%20a%20small%20rocket%20launching%20upward%20with%20a%20soft%20warm%20gradient%20background%20in%20pastel%20tones%20beginner%20journey%20concept%20clean%20modern%20flat%20design%20style&width=800&height=500&seq=pillar-beginner-01&orientation=landscape',
  },
  {
    slug: 'comparison',
    icon: 'ri-scales-3-line',
    readTime: '7 min read',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20minimal%20illustration%20of%20two%20balanced%20scales%20in%20soft%20sage%20and%20amber%20tones%20on%20a%20light%20cream%20background%20comparison%20concept%20clean%20modern%20flat%20design%20style&width=800&height=500&seq=pillar-comparison-01&orientation=landscape',
  },
  {
    slug: 'research',
    icon: 'ri-file-search-line',
    readTime: '7 min read',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20minimal%20illustration%20of%20a%20magnifying%20glass%20over%20small%20product%20cards%20in%20soft%20pastel%20colors%20on%20a%20light%20background%20product%20research%20concept%20clean%20modern%20flat%20design%20style&width=800&height=500&seq=pillar-research-01&orientation=landscape',
  },
  {
    slug: 'sellers',
    icon: 'ri-team-line',
    readTime: '6 min read',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20minimal%20illustration%20of%20connected%20people%20network%20icons%20in%20soft%20warm%20pastel%20tones%20on%20a%20light%20cream%20background%20trusted%20sellers%20concept%20clean%20modern%20flat%20design%20style&width=800&height=500&seq=pillar-sellers-01&orientation=landscape',
  },
];